export enum TypeModal {
  LOCATION = "location",
  STORAGE_BOX = "storage box",
}
